<template>
	<div>
		<b-checkbox v-model="isAllCheck" @input="onAllCheckChange">全選択/全解除</b-checkbox>
		<ul class="group-list">
			<li v-for="group in groups" :key="group.id">
				<b-checkbox v-model="checked"
					:native-value="group.id"
					@input="onCheckboxChange"
					>
					{{ group.name }}
				</b-checkbox>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: "CheckboxGroup",
	props: {
		groups: {
			type: Array,
			default: null,
		},
		checkedIds: {
			type: Array,
			default: null,
		},
	},
	components: {
	},
	data() {
		return {
			isAllCheck: false,
			checked: [],
		}
	},
	watch: {
		checkedIds: function() {
			this.checked = this.checkedIds;
		},
	},
	computed: {
	},
	mounted() {
	},
	methods: {
		onAllCheckChange: function() {
			if (!this.isAllCheck) {
				this.checked = [];
			} else {
				this.checked = this.groups.map(group => group.id);
			}
			this.$emit('checkbox-check', this.checked);
		},
		onCheckboxChange: function() {
			this.$emit('checkbox-check', this.checked);
		},
	}
}
</script>

<style scoped>
.group-list {
	border: 1px #dbdbdb solid;
	border-radius: 5px;
	padding: 10px;
	overflow: scroll;
	height: 150px;
}
</style>
